import emailjs from '@emailjs/browser';

// Mock data for PT. Kancalawas Damar Sakti website

export const companyInfo = {
  name: "PT. Kancalawas Damar Sakti",
  slogan: "Responsive And Flexible",
  description: "PT. Kancalawas Damar Sakti adalah perusahaan yang bergerak di bidang perdagangan umum dan jasa Information Technology (IT) dan Distribusi Elektronika dengan pengalaman tenaga Sumber Daya dalam bidang yang mencakup berbagai layanan pada instansi Pemerintah, Perbankan Industri dan Komersial, kami menggunakan produk dan teknologi terkini serta berkomitmen penuh pada praktik desain dan standar yang telah ditetapkan.",

  vision: "MENJADI PERUSAHAAN NASIONAL YANG TANGGUH, MAMPU TUMBUH DAN BERKEMBANG DALAM PERSAINGAN GLOBAL DAN MENJADI PERUSAHAAN PILIHAN UTAMA OLEH PELANGGAN DENGAN MEMBANGUN KEPERCAYAAN DAN MEMBERIKAN PELAYANAN TERBAIK DALAM PENGADAAN MATERIAL SESUAI KEBUTUHAN CUSTOMER",

  qualityPolicyTitle:
    "Kebijakan Management, keselamatan dan kesehatan kerja adalah merupakan kebijakan management PT. Kancalawas Damar Sakti yang bertujuan untuk melindungi karyawan, pihak lain yang terkait dalam bidang kerja, beserta pihak mitra usaha perusahaan serta masyarakat umum",

  qualityPolicyDesc:
    "PT. Kancalawas Damar Sakti, senantiasa berusaha mengelola resiko keselamatan dan kesehatan kerja dan dampak negatif yang dapat ditimbulkan akibat dari suatu musibah, sehingga faktor rentan sekecil apapun yang mungkin dapat menyebabkan kecelakaan kerja dapat diidentifikasi dan dihilangkan",

  contact: {
    address: "Wisma NH Lantai 5",
    street: "Jalan Raya Pasar Minggu No.2B-C2, Pancoran",
    city: "Jakarta Selatan",
    email: "info@kancalawas.com",
    phone: "+6221 27533884"
  }
};

export const services = [
  {
    id: 1,
    title: "ELECTRICAL, POWER DESIGN & ENGINEERING",
    description:
      "Bidang teknik yang berfokus pada perancangan, pengembangan, analisis, dan pengelolaan sistem kelistrikan serta distribusi tenaga listrik agar aman, efisien, dan andal."
  },
  {
    id: 2,
    title: "COOLING SYSTEM",
    description:
      "Sistem yang digunakan untuk menurunkan dan menjaga suhu suatu perangkat atau mesin agar tidak mengalami panas berlebih (overheating) sehingga tetap bekerja optimal dan aman."
  },
  {
    id: 3,
    title: "ARCHITECTURE & CIVIL WORK ENGINEERING",
    description:
      "Bidang yang berfokus pada perancangan bangunan dan pembangunan infrastruktur agar kuat, aman, fungsional, dan estetis."
  },
  {
    id: 4,
    title: "INFRASTRUCTURE CABLING SYSTEM",
    description:
      "Sistem jaringan kabel terstruktur yang digunakan untuk menghubungkan perangkat komunikasi, data, internet, dan listrik dalam suatu bangunan atau area."
  },
  {
    id: 5,
    title: "DATA & RACKING STRUCTURAL ENGINEERING",
    description:
      "Bidang yang berfokus pada perancangan struktur rak dan penempatan perangkat data/IT agar kuat, aman, rapi, dan efisien."
  },
  {
    id: 6,
    title: "SECURITY & MONITORING SYSTEMS DESIGN",
    description:
      "Bidang yang berfokus pada perancangan sistem keamanan dan pemantauan untuk melindungi area, aset, dan aktivitas."
  }
];

export const customers = [
  {
    id: 1,
    name: "Kementerian Perhubungan",
    logo: "https://kancalawas.com/uploads/customer1.png"
  },
  {
    id: 2,
    name: "Pertamina",
    logo: "https://kancalawas.com/uploads/customer2.png"
  },
  {
    id: 3,
    name: "Kementerian Sekretariat Negara",
    logo: "https://kancalawas.com/uploads/customer3.png"
  },
  {
    id: 4,
    name: "Kementerian Koordinator Pembangunan Manusia",
    logo: "https://kancalawas.com/uploads/customer4.png"
  },
  {
    id: 5,
    name: "Kementerian Pendidikan dan Kebudayaan",
    logo: "https://kancalawas.com/uploads/customer5.png"
  },
  {
    id: 6,
    name: "PT. King Plastic",
    logo: "https://kancalawas.com/uploads/customer6.png"
  },
  {
    id: 7,
    name: "PT. Elgayasa Media",
    logo: "https://kancalawas.com/uploads/customer7.png"
  },
  {
    id: 8,
    name: "PT. Tempo Scan Pacific Tbk",
    logo: "https://kancalawas.com/uploads/customer8.png"
  },
  {
    id: 9,
    name: "RSPAD Gatot Subroto",
    logo: "https://kancalawas.com/uploads/customer9.png"
  },
  {
    id: 10,
    name: "Saras Group",
    logo: "https://kancalawas.com/uploads/customer10.png"
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Data Center Infrastructure - Bank Mandiri",
    description: "Implementasi lengkap infrastruktur data center termasuk sistem pendingin, cabling, dan power distribution untuk kantor pusat Bank Mandiri.",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800",
    category: "Data Center",
    year: "2024"
  },
  {
    id: 2,
    title: "Smart Building System - Gedung Perkantoran",
    description: "Pemasangan sistem monitoring dan security terintegrasi untuk gedung perkantoran 15 lantai di Jakarta Selatan.",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800",
    category: "Smart Building",
    year: "2024"
  },
  {
    id: 3,
    title: "Network Infrastructure - Instansi Pemerintah",
    description: "Pembangunan infrastruktur jaringan fiber optic dan structured cabling untuk kantor pemerintahan.",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800",
    category: "Network",
    year: "2023"
  },
  {
    id: 4,
    title: "Power Distribution System - Pabrik Industri",
    description: "Desain dan instalasi sistem distribusi power untuk pabrik industri dengan kapasitas 2000 kVA.",
    image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=800",
    category: "Electrical",
    year: "2023"
  },
  {
    id: 5,
    title: "Cooling System Upgrade - Server Room",
    description: "Upgrade sistem pendingin presisi untuk ruang server dengan teknologi terkini yang lebih efisien.",
    image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800",
    category: "Cooling",
    year: "2024"
  },
  {
    id: 6,
    title: "CCTV & Access Control - Mall Shopping",
    description: "Implementasi sistem CCTV 360 kamera dan access control untuk kompleks mall di Tangerang.",
    image: "https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=800",
    category: "Security",
    year: "2023"
  },
  {
    id: 7,
    title: "Civil Work - Renovasi Kantor",
    description: "Renovasi dan pembangunan kantor modern dengan konsep green building di Jakarta Pusat.",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800",
    category: "Civil Work",
    year: "2024"
  },
  {
    id: 8,
    title: "Data Racking System - Cloud Provider",
    description: "Instalasi sistem racking dan cable management untuk fasilitas cloud computing.",
    image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800",
    category: "Data Center",
    year: "2023"
  },
  {
    id: 9,
    title: "Fire Detection System - Hospital",
    description: "Pemasangan sistem deteksi kebakaran dan alarm terintegrasi untuk rumah sakit 10 lantai.",
    image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800",
    category: "Security",
    year: "2024"
  },
  {
    id: 10,
    title: "UPS System Installation - Corporate Office",
    description: "Instalasi sistem UPS redundant untuk memastikan ketersediaan power 24/7 di kantor korporat.",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800",
    category: "Electrical",
    year: "2023"
  },
  {
    id: 11,
    title: "Building Automation - Hotel Bintang 5",
    description: "Implementasi sistem automasi gedung untuk hotel bintang 5 di Bali termasuk HVAC dan lighting control.",
    image: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800",
    category: "Smart Building",
    year: "2024"
  },
  {
    id: 12,
    title: "Structured Cabling - Tech Park",
    description: "Pembangunan infrastruktur cabling untuk kompleks tech park dengan 8 gedung kantor.",
    image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800",
    category: "Network",
    year: "2023"
  }
];

// Function untuk mengirim form ke email
export const submitContactForm = async (formData) => {

  try {

    const templateParams = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      time: new Date().toLocaleString('id-ID'),
      to_email: 'info@kancalawas.com'
    };

    const response = await emailjs.send(
      'service_t0ur2xn',
      'template_pfvwuud',
      templateParams,
      '9giOdQfgXJzwzeRFW'
    );

    console.log('SUCCESS!', response.status, response.text);

    return {
      success: true,
      message: 'Pesan Anda telah berhasil dikirim!'
    };

  } catch (error) {

    console.error('FAILED...', error);

    return {
      success: false,
      message: 'Gagal mengirim pesan'
    };
  }
};